/**
 * Global Imports
*/

import React, { useContext, useState } from 'react';

/**
 * Root Imports
*/

import { Message } from '~/components/Widget/';
import { LoginService } from '~/services/Auth';
import { GuestContext } from '~/components/Authenticator';

/**
 * Local Imports
*/

import { Login } from './Login';

/**
 * Exports
*/

export const AuthContext = React.createContext({
  errors: {}
});

/**
 * 
 */
export function GuestForms(props) {
  /** Contexts **/

  const guest = useContext(GuestContext);
  
  /** States **/

  const [ error, setError ] = useState({});

  /** Event Handlers **/

  /**
   * 
   */
  const handleAuthSuccess = (response) => {
    guest.authenticate(response.data);
  };

  /**
   * 
   */
  const handleError = (setSubmitting, error) => {
    setSubmitting(false);
    setError({
      ...error.response.data,
      fields: Object.keys( error.response.data.errors || {} )
    });
  };
  
  /**
  * 
  */
 const handleLogin = (values, { setSubmitting }) => {
   LoginService(values)
     .then(handleAuthSuccess)
     .catch(handleError.bind(this, setSubmitting))
   ;
 };

 /** Renderers **/

  /**
   * 
   */
  const renderErrorMessages = () => {
    const message = error.message;
    const errors = Object.entries(error.errors || {});

    if (!message) {
      return null;
    }

    return (
      <Message className='msg-error mb-4' onClose={ () => setError({}) }>
      {
        !errors.length ? <p>{ message }</p> :
          errors.map(([ field, messages ]) => (
            messages.map((message, index) => (
              <p key={ index }>{ message }</p>
            ))
          ))
      }
      </Message>
    );
  };

  /** **/

  /**
   * 
   */
  const buildContextHandlers = () => ({
    onLogin: handleLogin
  });

  /** Output **/

  return (
    <AuthContext.Provider value={{ errorFields : error.fields || [], ...buildContextHandlers() }}>
      { renderErrorMessages() }
      <Login/>
    </AuthContext.Provider>
  );
}